import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Mariana Costa",
    location: "Lisbon, Portugal",
    quote: "The career timing she gave me down to the month. I almost didn't believe it until it happened exactly then.",
    photo: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    name: "Sofia Alvarez",
    location: "Mexico City, MX",
    quote: "My compatibility reading finally explained why my relationship felt so easy and my last one felt impossible.",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    name: "Daniel Reyes",
    location: "Austin, USA",
    quote: "I've done three readings now. Every single one has been more accurate and more useful than any therapist session.",
    photo: "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    name: "Theo Larsen",
    location: "Copenhagen, DK",
    quote: "The tarot session gave me the clarity I needed to finally quit a job I'd been scared to leave for years.",
    photo: "https://images.unsplash.com/photo-1639747279286-c07eecb47a0b?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    name: "Carla Mendes",
    location: "São Paulo, Brazil",
    quote: "My yearly forecast flagged a 'big shift' month and that was the exact month I met my now-partner.",
    photo: "https://images.unsplash.com/photo-1665062173657-3912ae7991e0?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    name: "Helen Whitfield",
    location: "London, UK",
    quote: "I was skeptical of astrology my whole life. This reading changed that in one session. Deeply specific, deeply kind.",
    photo: "https://images.unsplash.com/photo-1612476929092-26a78fd1ea89?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

const Card = ({ r, dupIndex }) => (
  <div
    data-testid={`testimonial-card-${r.name.toLowerCase().replace(/\s+/g, "-")}-${dupIndex}`}
    className="glass-card p-7 w-[260px] sm:w-[320px] flex-shrink-0"
  >
    <div className="star-rating mb-4 flex gap-1">
      {[...Array(5)].map((_, i) => (
        <Star key={i} size={14} fill="#E8C27A" strokeWidth={0} />
      ))}
    </div>
    <p className="font-accent italic text-[#e3dffa] text-lg leading-relaxed mb-6">"{r.quote}"</p>
    <div className="flex items-center gap-3">
      <img src={r.photo} alt={`${r.name} portrait`} className="w-11 h-11 rounded-full object-cover border border-[#E8C27A]/30" />
      <div>
        <p className="text-sm font-medium">{r.name}</p>
        <p className="text-xs text-[#A99BFF]">{r.location}</p>
      </div>
    </div>
  </div>
);

export const Testimonials = () => {
  return (
    <section id="testimonials" className="cosmic-section max-w-full">
      <div className="text-center mb-16 max-w-7xl mx-auto px-6">
        <p className="reveal cosmic-eyebrow text-sm mb-5">Client Stories</p>
        <h2 className="reveal font-display text-3xl sm:text-4xl lg:text-5xl">Written in the Stars, Felt in Real Life</h2>
      </div>

      <div className="marquee-row" data-testid="testimonials-marquee">
        <div className="marquee-track">
          {[0, 1].map((dupIndex) =>
            REVIEWS.map((r) => <Card key={`${dupIndex}-${r.name}`} r={r} dupIndex={dupIndex} />)
          )}
        </div>
      </div>
    </section>
  );
};
